import React, { useEffect, useMemo, useState } from "react";
import { BiEdit } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import BackButton from "./BackButton";
import { base_url } from "../env";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import {  TextField, ThemeProvider } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "antd";
import { createTheme } from '@mui/material/styles';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
export default function License() {
  const ApiData = useSelector((state) => state.ApiData.filteredData); // Assuming ApiData contains the filtered licenses.
  const navigate = useNavigate();
  const [licenses, setLicenses] = useState([]);
  const [loading, setLoading] = useState(true); // Track loading state
  console.log(licenses);
  const Theme = { primaryThemeColor: "#1976d2" };
  const formattedDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0"); // Ensure 2 digits for day
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const fetchLicenses = () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
    const adminTokken=localStorage.getItem("userToken")

      const raw = JSON.stringify({
        tokenData:adminTokken,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${base_url}/Admin_LicenseList`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === false) {
            toast.error("Couldn't fetch licences",{autoClose:3000})
          } else {
          if (result?.data) {
            setLicenses(result.data); // Assuming result.data contains the licenses.
          }            
          }

        })
        .catch((error) => {
          toast.error("Couldn't fetch licences",{autoClose:3000})
          console.error(error)})
        .finally(() => setLoading(false)); // Set loading to false after data fetch is complete
    };

    fetchLicenses();
  }, []);

  const editLicense = (licenseId, item) => {
    navigate(`/editlicense/${licenseId}`, {
      state: item,
    });
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const handleSearch = (e) => {
    setSearchTerm(e.target.value); // Update the search term
  };

  const handleEdit = () => {
    navigate("/newlicense");
  };

  const data = licenses;
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  

  const Tabel = () => {
    // Memoize columns
    const columns = useMemo(
      () => [
        {
          accessorKey: "LiceNo", // Access nested data with dot notation
          header: "LiceNo",
          size: 150,
        },
        {
          accessorKey: "LiceDeviceID",
          header: "LiceDeviceID",
          size: 150,
        },
        {
          accessorKey: "LiceCompanyName", // Normal accessorKey
          header: "LiceCompanyName",
          size: 200,
        },
        {
          accessorFn: (date) => (date?.Details[0]?.LiceRenewalDate),
          Cell: ({ cell }) => dayjs(cell.getValue()).format('DD/MM/YYYY'),
          header: 'License Date',
          filterFn: (row, columnId, filterValue) => {
              const { startDate, endDate } = filterValue;
              const date = dayjs(row.getValue(columnId));
              if (startDate && endDate) {
                  return date.isBetween(startDate, endDate, "day","[]"  );
              }
              return true;
          },
          Filter: ({ column, table }) => {
              const handleFilterChange = (startDate, endDate) => {
                  table.setColumnFilters([{ id: column.id, value: { startDate: startDate ? dayjs(startDate, 'DD-MM-YYYY') : null, endDate: endDate ? dayjs(endDate, 'DD-MM-YYYY') : null } }]);
              };
              return (
                  <ThemeProvider theme={createTheme({ palette: { primary: { main: Theme.primaryThemeColor } } })}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div style={{ display: 'flex', gap: '1rem' }}>
                              <DatePicker
                                  value={column.getFilterValue()?.startDate}
                                  format="DD-MM-YYYY"
                                  onChange={(newValue) => handleFilterChange(newValue?.format('DD-MM-YYYY'), column.getFilterValue()?.endDate)}
                                  renderInput={(params) => (
                                      <TextField
                                          {...params}
                                          value={column.getFilterValue()?.startDate ? dayjs(column.getFilterValue()?.startDate).format('DD-MM-YYYY') : ''}
                                      />
                                  )}
                              />
                              <DatePicker
                                  value={column.getFilterValue()?.endDate}
                                  format="DD-MM-YYYY"
                                  onChange={(newValue) => handleFilterChange(column.getFilterValue()?.startDate, newValue?.format('DD-MM-YYYY'))}
                                  renderInput={(params) => (
                                      <TextField
                                          {...params}
                                          value={column.getFilterValue()?.endDate ? dayjs(column.getFilterValue()?.endDate).format('DD-MM/YYYY') : ''}
                                      />
                                  )}
                              />
                          </div>
                      </LocalizationProvider>
                  </ThemeProvider>
              );
          },
      },
        {
          accessorFn: (date) => {
            const length=date?.Details.length;
            return (date?.Details[length-1]?.LiceExpiryDate)},
          Cell: ({ cell }) => dayjs(cell.getValue()).format('DD/MM/YYYY'),
          header: 'Expiry Date',
          filterFn: (row, columnId, filterValue) => {
              const { startDate, endDate } = filterValue;
              const date = dayjs(row.getValue(columnId));
              if (startDate && endDate) {
                  return date.isBetween(startDate, endDate, "day", "[]" );
              }
              return true;
          },
          Filter: ({ column, table }) => {
              const handleFilterChange = (startDate, endDate) => {
                  table.setColumnFilters([{ id: column.id, value: { startDate: startDate ? dayjs(startDate, 'DD-MM-YYYY') : null, endDate: endDate ? dayjs(endDate, 'DD-MM-YYYY') : null } }]);
              };
              return (
                  <ThemeProvider theme={createTheme({ palette: { primary: { main: Theme.primaryThemeColor } } })}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div style={{ display: 'flex', gap: '1rem' }}>
                              <DatePicker
                                  value={column.getFilterValue()?.startDate}
                                  format="DD-MM-YYYY"
                                  onChange={(newValue) => handleFilterChange(newValue?.format('DD-MM-YYYY'), column.getFilterValue()?.endDate)}
                                  renderInput={(params) => (
                                      <TextField
                                          {...params}
                                          value={column.getFilterValue()?.startDate ? dayjs(column.getFilterValue()?.startDate).format('DD-MM-YYYY') : ''}
                                      />
                                  )}
                              />
                              <DatePicker
                                  value={column.getFilterValue()?.endDate}
                                  format="DD-MM-YYYY"
                                  onChange={(newValue) => handleFilterChange(column.getFilterValue()?.startDate, newValue?.format('DD-MM-YYYY'))}
                                  renderInput={(params) => (
                                      <TextField
                                          {...params}
                                          value={column.getFilterValue()?.endDate ? dayjs(column.getFilterValue()?.endDate).format('DD-MM/YYYY') : ''}
                                      />
                                  )}
                              />
                          </div>
                      </LocalizationProvider>
                  </ThemeProvider>
              );
          },
      },
        
        
        {
          header: "Actions", // Custom column for the icon
          id: "actions",
          accessorKey: "actions", // Doesn't need to map to any data field
          Cell: ({ row }) => (
            <div
              onClick={() => handleCustomFunctionality(row)}
              style={{ fontSize: "15px" }}
            >
              <BiEdit /> {/* Replace with your custom icon */}
            </div>
          ),
          size: 100,
        },
      ],
      []
    );

    const handleCustomFunctionality = (row) => {
      const item = row.original;
      const licenseId = row.original.LiceID;

      navigate(`/editlicense/${licenseId}`, {
        state: item,
      });
    };

    const table = useMaterialReactTable({
      columns,
      data,
      enableStickyHeader: true,
      enableBottomToolbar:false,
      enablePagination:false,
      enableRowNumbers: true, // Data must be memoized or stable
      initialState:{density:"compact"},
      muiTableHeadCellProps: {
        sx: {
          bgcolor: '#a5d8dd', // Primary color
          color: 'black', // Text color for header
          fontWeight: 'bold', // Optional: bold header text
        }
      },
      renderTopToolbarCustomActions: ({ table }) => (<div className="w-100"></div>
      //   <div className="container-fluid p-0  w-50 m-0 d-flex justify-content-between">
      //   <div className="heading h4">
      //     <div className="d-inline p-0 mx-2 ">
      //       <BackButton />
      //     </div>
      //     License
      //   </div>

      //   <div className="heading">
      //     <a
      //       name=""
      //       id=""
      //       class="btn btn-primary px-4"
      //       role="button"
      //       onClick={handleEdit}
      //     >
      //       Add
      //     </a>
      //   </div>
      // </div>
      ),
    });

    return <MaterialReactTable table={table} />;
  };

  return (
    <>
      <ToastContainer/>
      {/* <SubHeader Name={"License"} newlicense={"newlicense"} /> */}
         <div className="container-fluid p-0  w-100 m-0 d-flex justify-content-between">
         <div className="heading h4">
           <div className="d-inline p-0 mx-2 ">
             <BackButton />
           </div>
           License
         </div>
         <div className="heading">
           <a
             name=""
             id=""
             class="btn btn-primary px-4"
             role="button"
             onClick={handleEdit}
           >
             Add
           </a>
         </div>
       </div>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "70vh" }}
        >
          <CircularProgress />
        </div>
      ) : licenses.length > 0 ? (
        <Tabel />
      ) : (
        <h3 className="text-center">No licenses found</h3>
      )}
    </>
  );
}
